var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.04 71.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #110bff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.96,0H3.08C1.38,0,0,1.37,0,3.08v56.87c0,1.15.63,2.15,1.57,2.68.44.25.96.4,1.51.4h24.99v4.51h35.91v-4.51h24.99c.55,0,1.06-.15,1.51-.4.93-.53,1.57-1.53,1.57-2.68V3.08c0-1.7-1.38-3.08-3.08-3.08Zm.44,59.94c0,.24-.19.44-.44.44H3.08c-.24,0-.44-.2-.44-.44V3.08c0-.24.2-.44.44-.44h85.89c.25,0,.44.2.44.44v56.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.71,
    y: 69.51,
    width: 58.52,
    height: 2.42
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.45,
    y: 21.03,
    width: 45.03,
    height: 21.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.53f6628e5daab8e71fcc440fa17d2649.svg";
export { ForwardRef as ReactComponent };